export default {
  "fa-envelope": "fas",
  "fa-phone-alt": "fas",
  "fa-file-alt": "fas",
  "fa-skype": "fab",
  "fa-vk": "fab",
  "fa-linkedin": "fab",
  "fa-code": "fas",
}
